"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.demandContractsCreateConfig = void 0;
exports.demandContractsCreateConfig = {
    canCreateDemandContracts: true,
    showCreateNewDemandContractButton: true,
};
